/**
 * 날짜 필터(`<DateInput>`의 'YYYY-MM-DD')를 **로컬 하루의 경계**로 바꿔 UTC ISO로 돌려준다.
 *
 * 'YYYY-MM-DD'를 그대로 보내면 서버가 `new Date(raw)` = **UTC 자정**으로 읽어 gte/lte를 건다 —
 * KST 하루가 9시간 밀리고 종료일은 그 날 09:00 KST 이후가 통째로 빠진다(리뷰 1103 F22).
 * 시작은 로컬 00:00, 끝은 로컬 23:59:59.999(`.999`가 없으면 마지막 1초가 빠진다).
 *
 * 쓰는 자리: `Reports.tsx`(이 형판의 원본) · `SyncHistory.tsx` · `UserFeedback.tsx`.
 * 빈 값이면 `undefined`(필터 없음).
 */
export function localDayStartIso(day: string): string | undefined {
  return day ? new Date(`${day}T00:00:00`).toISOString() : undefined;
}

export function localDayEndIso(day: string): string | undefined {
  return day ? new Date(`${day}T23:59:59.999`).toISOString() : undefined;
}
